import { render, staticRenderFns } from "./Validation.vue?vue&type=template&id=06d64f84&scoped=true"
import script from "./Validation.vue?vue&type=script&lang=js"
export * from "./Validation.vue?vue&type=script&lang=js"
import style0 from "./Validation.vue?vue&type=style&index=0&id=06d64f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d64f84",
  null
  
)

export default component.exports